import React, { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Label, Table } from "reactstrap";
import { CircularProgress } from "../../UI/CircularProgress/CircularProgress";
import { Col, Row } from "../../../components/UI/Customstrap/Customstrap";
import { getSavedPersonInfo } from "../../../reducers/selectors";
import GenericButton from "../../../components/UI/Button/Button";
import confirmIcon from "../../../../public/svg/ButtonIcons/right-arrow.svg";
import style from "./ConfirmDataOnboarding.scss";
import { HeaderOnboarding } from "../HeaderOnboarding/HeaderOnboarding";
import { ContractOnboarding } from "../ContractOnboarding/ContractOnboarding";

export const ConfirmDataOnboarding = ({
  activeSidebar,
  toggleMobileSidebar,
  confirmPersonInfo,
  confirmContract,
  confirmAccounts,
  confirmInvestmentProfile,
}) => {
  const [showPep, setShowPep] = useState(false);
  const personInfo = useSelector(getSavedPersonInfo);
  const [showContract, setShowContract] = useState(false);
  const [mobilePhone, setMobilePhone] = useState({
    PhoneNumber: "",
  });
  const [personDocument, setPersonDocument] = useState({
    PhysicalPersonDocumentTypeName: "",
    PhysicalPersonDocumentNumber: "",
  });
  const [legalAddress, setLegalAddress] = useState({
    LegalAddressStreet: "",
    LegalAddressCityName: "",
  });

  const genderString = {
    N: "No especificado",
    M: "Masculino",
    F: "Femenino",
  };

  const civilStatusString = {
    Single: "Soltero/a",
    Engaged: "Comprometido/a",
    Married: "Casado/a",
    Divorced: "Divorciado/a",
    Widower: "Viudo/a",
  };

  useEffect(() => {
    // actualizar datos de persona
    if (personInfo) {
      if (personInfo.Phone.length > 0) {
        setMobilePhone((prev) => ({
          ...prev,
          ...personInfo.Phone[0],
        }));
      }

      if (personInfo.Documents.length > 0) {
        const newPersonDocument = personInfo.Documents.find(
          (documentItem) => documentItem.PhysicalPersonDocumentIsMain
        );
        setPersonDocument((prev) => ({
          ...prev,
          ...newPersonDocument,
        }));
      }

      if (personInfo.LegalAddress.length > 0) {
        const newLegalAddress = personInfo.LegalAddress[0];
        setLegalAddress((prev) => ({
          ...prev,
          ...newLegalAddress,
        }));
      }
    }
  }, [personInfo]);

  const toggleShowContract = () => {
    confirmPersonInfo();
    setShowContract((stateContract) => !stateContract);
  };

  if (!personInfo) return <CircularProgress />;

  return (
    <div className={activeSidebar ? style.noContainer : style.containerData}>
      <HeaderOnboarding title="Confirmá tus datos" toggleMobileSidebar={toggleMobileSidebar} />
      <Row className={style.headerTitle}>
        <Label>Confirmá tus datos</Label>
      </Row>
      <Row className={style.dataRow}>
        <Col>
          <div className={style.boxData}>
            <div className={style.data}>
              <div className={style.dataTitle}> Datos personales </div>
              <div className={style.divider}></div>
            </div>
            <Table className={style.table}>
              <tbody>
                <tr>
                  <td>
                    <strong>Nombre y apellido: </strong>
                    {`${personInfo.PhysicalPersonFirstName} ${personInfo.PhysicalPersonFirstLastName}`}
                  </td>
                  <td className={style.column}>
                    <strong>Correo electrónico: </strong>
                    {personInfo.PhysicalPersonEmail}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Dirección: </strong>
                    {`${legalAddress.LegalAddressStreet} ${legalAddress.LegalAddressNumber}, ${legalAddress.LegalAddressCityName}`}
                  </td>
                  <td className={style.column}>
                    <strong>Celular: </strong>
                    {mobilePhone.PhoneNumber}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className={style.boxData}>
            <div className={style.data}>
              <div className={style.dataTitle}> Documento </div>
              <div className={style.divider}></div>
            </div>
            <Table className={style.table}>
              <tbody>
                <tr>
                  <td>
                    <strong>Tipo de documento: </strong>
                    {"Cédula de Identidad"}
                  </td>
                  {/* <td><strong>Tipo de documento: </strong>{personDocument.PhysicalPersonDocumentTypeName}</td> */}
                  <td className={style.column}>
                    <strong>Nacionalidad: </strong>
                    {personInfo.PhysicalPersonNationality}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Número de documento: </strong>
                    {personDocument.PhysicalPersonDocumentNumber}
                  </td>
                  <td className={style.column}>
                    <strong>Lugar de nacimiento: </strong>
                    {personInfo.PhysicalPersonCityOfBirthName}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Fecha de nacimiento: </strong>
                    {moment(personInfo.PhysicalPersonDateOfBirth).format("DD/MM/YYYY")}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className={style.boxData}>
            <div className={style.data}>
              <div className={style.dataTitle}> Datos laborales </div>
              <div className={style.divider}></div>
            </div>
            <Table className={style.table}>
              <tbody>
                <tr>
                  <td>
                    <strong>Ocupación: </strong>
                    {personInfo.PersonProfessionName}
                  </td>
                  <td className={style.column}>
                    <strong>Nombre de la empresa: </strong>
                    {personInfo.PersonWorkingBy}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Actividad del negocio: </strong>
                    {personInfo.PersonActivitySectorName}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className={style.buttonContainer}>
            <GenericButton
              label={"Confirmar"}
              rounded
              padding={"8px 46px"}
              primary
              right
              handleClick={toggleShowContract}
              iconSvg={[{ width: "16px", item: confirmIcon }]}
            ></GenericButton>
          </div>
        </Col>
      </Row>
      {showContract && (
        <ContractOnboarding
          toggleMobileSidebar={toggleMobileSidebar}
          confirmContract={confirmContract}
          confirmAccounts={confirmAccounts}
          confirmInvestmentProfile={confirmInvestmentProfile}
        />
      )}
    </div>
  );
};
